<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Creating Product Code
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-form @submit.prevent="submitForm">
      <validation-observer
        ref="codeCreateForm"
        #default="{invalid}"
      >
        <b-card
          header-tag="header"
        >
          <b-row>
            <b-col md="12">
              <b-alert
                variant="warning"
                show
                class="mt-50"
              >
                <div class="alert-body d-flex">
                  <feather-icon
                    icon="AlertTriangleIcon"
                    size="20"
                    class="my-auto mr-1"
                  />
                  <div>
                    <span class="weight-400 fs-14">Please ensure that there is a corresponding Product Code in SCLC. Creating a Product Code here <strong class="weight-700">does not</strong> automatically create a Product in SCLC, that has to be done manually. Make sure the data here matches exactly to a Product record in SCLC.</span>
                  </div>
                </div>
              </b-alert>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="SCLC Product Code ID*"
                label-cols-md="3"
                label-for="sclcID"
              >
                <validation-provider
                  #default="{ errors }"
                  name="SCLC Product Code"
                  vid="sclcID"
                  rules="required"
                >
                  <b-form-input
                    id="sclcID"
                    v-model="sclcID"
                    :state="(errors.length > 0) ? false : null"
                    name="sclcID"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="sclcIDValidation"
                    class="text-danger"
                  >
                    {{ sclcIDError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Product Code*"
                label-cols-md="3"
                label-for="code"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Product Code"
                  vid="code"
                  rules="required"
                >
                  <b-form-input
                    id="code"
                    v-model="code"
                    :state="(errors.length > 0) ? false : null"
                    name="code"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="codeValidation"
                    class="text-danger"
                  >
                    {{ codeError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Product Description*"
                label-cols-md="3"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Product Description"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="(errors.length > 0) ? false : null"
                    name="name"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="nameValidation"
                    class="text-danger"
                  >
                    {{ nameError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="Product Category"
                vid="category"
                rules="required"
              >
                <b-form-group
                  label="Product Category*"
                  label-for="h-team-category"
                  label-cols-md="3"
                  :state="(errors.length > 0 || categoryValidation) ? false : null"
                >
                  <v-select
                    id="h-team-category"
                    v-model="category"
                    label="name"
                    :options="categoryOptions"
                    :reduce="title => title._id"
                    :clearable="false"
                    placeholder="Select from list"
                    @input="categoryValidation == true ? categoryValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="categoryValidation"
                    class="text-danger"
                  >
                    {{ categoryError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="Lot Based"
                vid="lotBased"
                rules="required"
              >
                <b-form-group
                  label="Lot Based*"
                  label-for="h-team-lotBased"
                  label-cols-md="3"
                  :state="(errors.length > 0 || lotBasedValidation) ? false : null"
                >
                  <v-select
                    id="h-team-lotBased"
                    v-model="lotBased"
                    label="title"
                    :options="lotBasedOption"
                    :reduce="title => title.code"
                    :clearable="false"
                    @input="lotBasedValidation == true ? lotBasedValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="lotBasedValidation"
                    class="text-danger"
                  >
                    {{ lotBasedError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="File Sequence Prefix*"
                label-cols-md="3"
                label-for="fileSequence"
              >
                <validation-provider
                  #default="{ errors }"
                  name="File Sequence Prefix"
                  vid="fileSequence"
                  rules="required"
                >
                  <b-form-input
                    id="fileSequence"
                    v-model="fileSequence"
                    :state="(errors.length > 0) ? false : null"
                    name="fileSequence"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="fileSequenceValidation"
                    class="text-danger"
                  >
                    {{ fileSequenceError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="CN Discount Code*"
                label-cols-md="3"
                label-for="cnDiscountCode"
              >
                <validation-provider
                  #default="{ errors }"
                  name="CN Discount Code"
                  vid="cnDiscountCode"
                  rules="required"
                >
                  <b-form-input
                    id="cnDiscountCode"
                    v-model="cnDiscountCode"
                    :state="(errors.length > 0) ? false : null"
                    name="cnDiscountCode"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="cnDiscountCodeValidation"
                    class="text-danger"
                  >
                    {{ cnDiscountCodeError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-nav class="wrap-border save-nav">
          <li
            class="nav-item ml-auto"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              :to="{ name: 'products-codes-index' }"
            >
              Cancel
            </b-button>
          </li>
          <li
            class="nav-item mr-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              :disabled="invalid"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              <span class="align-middle">Create Product Code</span>
            </b-button>
          </li>
        </b-nav>
      </validation-observer>
    </b-form>
    <!-- create new category modal -->
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BNav, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BNav,
    BAlert,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      name: '',
      code: '',
      sclcID: '',
      category: '',
      lotBased: 'yes',
      fileSequence: '',
      cnDiscountCode: '',
      nameError: 'Valid Name is required',
      nameValidation: false,
      codeError: 'Valid code is required',
      codeValidation: false,
      sclcIDError: 'Valid ID is required',
      sclcIDValidation: false,
      categoryError: 'Valid category is required',
      categoryValidation: false,
      lotBasedError: 'Valid value is required',
      lotBasedValidation: false,
      fileSequenceError: 'Valid sequence is required',
      fileSequenceValidation: false,
      cnDiscountCodeError: 'Valid Discount Code is required',
      cnDiscountCodeValidation: false,
      categoryOptions: [],
      lotBasedOption: [{ title: 'Yes', code: 'yes' }, { title: 'No', code: 'no' }],
      // validation rules
      required,
    }
  },
  beforeMount() {
    this.$http.get('reservation/product-category/respond-with/name-and-id')
      .then(response => {
        this.categoryOptions = response.data.categories ?? []
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    submitForm() {
      this.$refs.codeCreateForm.validate().then(async success => {
        if (success) {
          const formData = new FormData()

          formData.append('name', this.name)
          formData.append('code', this.code)
          formData.append('sclcID', this.sclcID)
          formData.append('category', this.category)
          formData.append('lotBased', this.lotBased)
          formData.append('fileSequence', this.fileSequence)
          formData.append('cnDiscountCode', this.cnDiscountCode)
          this.$http.post('reservation/product-code/store', formData)
            .then(() => {
              this.$swal({
                title: 'Product Code Created',
                html: 'This code is now available to connect to product catalogs.',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/success.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
                .then(result => {
                  if (result.value) {
                    this.$router.push({ name: 'products-codes-index' })
                  }
                })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'name') {
                    this.nameError = validationError.msg
                    this.nameValidation = true
                  } else if (validationError.param === 'code') {
                    this.codeError = validationError.msg
                    this.codeValidation = true
                  } else if (validationError.param === 'sclcID') {
                    this.sclcIDError = validationError.msg
                    this.sclcIDValidation = true
                  } else if (validationError.param === 'category') {
                    this.categoryError = validationError.msg
                    this.categoryValidation = true
                  } else if (validationError.param === 'lotBased') {
                    this.lotBasedError = validationError.msg
                    this.lotBasedValidation = true
                  } else if (validationError.param === 'fileSequence') {
                    this.fileSequenceError = validationError.msg
                    this.fileSequenceValidation = true
                  } else if (validationError.param === 'cnDiscountCode') {
                    this.cnDiscountCodeError = validationError.msg
                    this.cnDiscountCodeValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>
